export default "__VITE_ASSET__DNRDB3E4__"